<template>
    <div v-bind:style="{ height: height + 'px' }">
        <MglMap
                :accessToken="mapToken"
                :mapStyle.sync="mapStyle"
                :pitch="pitch"
                :zoom="zoom"
                @load="onMapLoaded"
                :center="[centerLon, centerLat]"
        >
        <MglMarker v-if="markers" v-for="marker in markers" :coordinates="[marker.lon,marker.lat]">
            <template slot="marker">
                <div class="cursor-as-pointer">
                    <div v-if="!marker.thumb" class="caption text-uppercase"
                         style="text-align:center;position: absolute; top: 50%; left: 50%; transform: translate(-50%, -200%); width:200px;">
                        {{marker.name}}
                    </div>
                    <v-icon v-if="!marker.thumb" large v-on="on" @click="openMarkerLink(marker)">fa-map-marker-alt</v-icon>
                    <v-tooltip top v-if="marker.thumb">
                        <template v-slot:activator="{ on }">
                            <div class="caption text-uppercase"
                                 style="text-align:center;position: absolute; top: 50%; left: 50%; transform: translate(-50%, -200%); width:200px;">
                                {{marker.name}}
                            </div>
                            <v-icon large v-on="on" @click="openMarkerLink(marker)">fa-map-marker-alt</v-icon>
                        </template>
                        <div style="width:300px;" @click="openMarkerLink(marker)">
                            <v-img :src="marker.thumb"></v-img>
                            <h2 class="mt-2 mb-2">{{marker.name}}</h2>
                        </div>
                    </v-tooltip>
                </div>
            </template>
        </MglMarker>
        </MglMap>
    </div>
</template>

<script>
    import Mapbox from "mapbox-gl";
    import {MglMap, MglMarker} from "vue-mapbox";
    export default {
        props: {
            height: {type: Number, default: 500},
            mapToken: {
                type: String,
                default: "pk.eyJ1IjoiYWxleGRvYnJlIiwiYSI6ImNrN3BtZHZxcTAyMGwzcmwyaDA1cnR0ODMifQ.qUYFNvUiAyO9XaM_vRajWw"
            },
            mapStyle: {type: String, default: "mapbox://styles/alexdobre/ck7zqwh9i2e681intld6eat26"},
            pitch: {type: Number, default: 30},
            zoom: {type: Number, default: 16},
            centerLon: {type: Number, default: 114.1584},
            centerLat: {type: Number, default: 22.282225},
            markers: {type: Array, default: null},
        },
        components: {
            MglMap, MglMarker
        },
        computed: {},
        name: 'MapWidget',
        watch: {},
        data: function () {
            return {
                mapActions: null,
            }
        },
        methods: {
            onMapLoaded(event) {
                this.mapActions = event.component.actions;
            },
            openMarkerLink(marker) {
                if (marker.link) {
                    let pass = localStorage.getItem('pass');
                    window.open(marker.link + "?token=" + pass, '_blank');
                }

            },

        },
        created() {
            this.mapbox = Mapbox;
        },
    }

</script>

<style scoped>

</style>
